import { useMemo, useState } from "react";
import {
  FaEye,
  FaSearch,
  FaUserTie,
} from "react-icons/fa";

const applicants = [
  {
    id: 1,
    name: "Wisdom Okposin",
    position: "Backend Developer",
    qualification: "B.Eng Electrical Engineering",
    email: "wisdom@gmail.com",
    status: "New",
    applied: "2 hours ago",
  },
  {
    id: 2,
    name: "Sarah Johnson",
    position: "Frontend Developer",
    qualification: "B.Sc Computer Science",
    email: "sarah@gmail.com",
    status: "Reviewed",
    applied: "Yesterday",
  },
  {
    id: 3,
    name: "David Wilson",
    position: "UI/UX Designer",
    qualification: "B.Tech Computer Science",
    email: "david@gmail.com",
    status: "Shortlisted",
    applied: "3 days ago",
  },
];

export default function ApplicantLogs() {
  const [search, setSearch] = useState("");

  const filtered = useMemo(() => {
    return applicants.filter((applicant) =>
      `${applicant.name} ${applicant.position}`
        .toLowerCase()
        .includes(search.toLowerCase())
    );
  }, [search]);

  const badgeColor = (status: string) => {
    switch (status) {
      case "New":
        return "bg-blue-100 text-blue-700";
      case "Reviewed":
        return "bg-yellow-100 text-yellow-700";
      case "Shortlisted":
        return "bg-green-100 text-green-700";
      case "Rejected":
        return "bg-red-100 text-red-700";
      default:
        return "bg-gray-100 text-gray-600";
    }
  };

  return (
    <div className="p-6">

      {/* Header */}

      <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between mb-6">
        <div>
          <h2 className="text-2xl font-bold text-gray-800">
            Job Applications
          </h2>
          <p className="text-gray-500">
            View and manage all applicants.
          </p>
        </div>

        <div className="relative w-full md:w-80">
          {FaSearch({ className: "absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" })}

          <input
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search applicant..."
            className="w-full rounded-lg border py-3 pl-11 pr-4 outline-none focus:border-blue-500"
          />
        </div>
      </div>

      {/* Table */}

   <div className="overflow-hidden rounded-xl border bg-white shadow-sm">

  {/* Desktop */}
  <div className="hidden overflow-x-auto md:block">
    <table className="w-full">
      <thead className="bg-gray-50">
        <tr className="text-left text-sm text-gray-600">
          <th className="px-6 py-4">Applicant</th>
          <th className="px-6 py-4">Position</th>
          <th className="px-6 py-4">Qualification</th>
          <th className="px-6 py-4">Applied</th>
          <th className="px-6 py-4">Status</th>
          <th className="px-6 py-4 text-center">Action</th>
        </tr>
      </thead>

      <tbody>
        {filtered.map((item) => (
          <tr
            key={item.id}
            className="border-t hover:bg-gray-50"
          >
            <td className="px-6 py-5">
              <div className="flex items-center gap-3">
                <div className="flex h-11 w-11 items-center justify-center rounded-full bg-blue-100">
                  {FaUserTie({ className: "text-blue-600" })}
                </div>

                <div>
                  <h4 className="font-semibold">{item.name}</h4>
                  <p className="text-sm text-gray-500">
                    {item.email}
                  </p>
                </div>
              </div>
            </td>

            <td className="px-6">{item.position}</td>

            <td className="px-6">
              {item.qualification}
            </td>

            <td className="px-6 text-gray-500">
              {item.applied}
            </td>

            <td className="px-6">
              <span
                className={`rounded-full px-3 py-1 text-xs font-semibold ${badgeColor(
                  item.status
                )}`}
              >
                {item.status}
              </span>
            </td>

            <td className="px-6 text-center">
              <button className="rounded-lg p-2 text-blue-600 hover:bg-blue-50">
                {FaEye({})}
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>

  {/* Mobile */}
  <div className="divide-y md:hidden">
    {filtered.map((item) => (
      <div
        key={item.id}
        className="p-4"
      >
        <div className="flex items-start justify-between">

          <div className="flex gap-3">

            <div className="flex h-12 w-12 items-center justify-center rounded-full bg-blue-100">
              {FaUserTie({ className: "text-blue-600" })}
            </div>

            <div>
              <h3 className="font-semibold">
                {item.name}
              </h3>

              <p className="text-sm text-gray-500">
                {item.email}
              </p>
            </div>

          </div>

          <button className="rounded-lg p-2 text-blue-600 hover:bg-blue-50">
            {FaEye({})}
          </button>

        </div>

        <div className="mt-4 space-y-3 text-sm">

          <div className="flex justify-between">
            <span className="text-gray-500">Position</span>
            <span className="font-medium">
              {item.position}
            </span>
          </div>

          <div className="flex justify-between">
            <span className="text-gray-500">Qualification</span>
            <span className="text-right max-w-[60%]">
              {item.qualification}
            </span>
          </div>

          <div className="flex justify-between">
            <span className="text-gray-500">Applied</span>
            <span>{item.applied}</span>
          </div>

          <div className="flex items-center justify-between">
            <span className="text-gray-500">Status</span>

            <span
              className={`rounded-full px-3 py-1 text-xs font-semibold ${badgeColor(
                item.status
              )}`}
            >
              {item.status}
            </span>
          </div>

        </div>
      </div>
    ))}
  </div>

</div>
    </div>
  );
}